@if (imageData) {
  <app-document-viewer [resourceName]="imageData.resource" [documentId]="imageData.documentId"
  [config]="{showTypeDropdown: false }" [imageData]="imageData"></app-document-viewer>
}